// pp-calc-relleno.js — ¿Cuánto Relleno Necesito por Caja?
// (/pages/cuanto-relleno-necesito)
//
// Dos materiales, dos filosofías:
//
//   PAPEL KRAFT ARRUGADO — llena el VACÍO que queda entre producto y caja.
//     Regla práctica de Para Paquetes: 1 metro lineal de rollo kraft de 60 cm
//     arrugado rellena ≈ 8 litros. metros = vacío (L) ÷ 8, redondeado a 0.5
//     hacia arriba.
//
//   ROLLO DE BURBUJA — envuelve el PRODUCTO, no llena el vacío. Regla
//     práctica: 2 vueltas de burbuja por cara ⇒
//     m² por pieza = 2 × superficie del producto = 2 × (2×(L×A + L×H + A×H))
//     y con rollo de 1 m de ancho, los m² son directamente metros lineales.
//
// Ambas son estimaciones editoriales ("regla práctica de Para Paquetes —
// ajusta a tu producto"), no física exacta. Aritmética pura probada en
// tests/calc-relleno.test.mjs.
(function (root) {
  'use strict';

  var LITROS_POR_METRO_KRAFT = 8; // 1 m de rollo kraft 60 cm arrugado ≈ 8 L
  var CAPAS_BURBUJA = 2;          // 2 vueltas por cara
  var ANCHO_ROLLO_BURBUJA_M = 1;  // rollo de burbuja de 1 m de ancho
  var ROLLO_DEFAULT_M = { kraft: 100, burbuja: 50 };

  // Redondeo a 0.5 hacia arriba: 2.25 → 2.5, 0.44 → 0.5, 2.0 → 2.0.
  function aMedios(x) {
    return Math.ceil(x * 2 - 1e-9) / 2;
  }

  // ¿Cabe el producto en la caja en ALGUNA orientación? Se comparan las
  // ternas ordenadas de mayor a menor: si cada dimensión del producto cabe
  // en la correspondiente de la caja, cabe girándolo.
  function cabe(prod, caja) {
    var p = prod.slice().sort(function (a, b) { return b - a; });
    var c = caja.slice().sort(function (a, b) { return b - a; });
    return p[0] <= c[0] && p[1] <= c[1] && p[2] <= c[2];
  }

  // Entradas: cajaL/cajaA/cajaH (interior, cm), prodL/prodA/prodH (cm),
  // material ('kraft'|'burbuja'), pedidosMes (opcional),
  // rolloMetros (opcional; default 100 m kraft / 50 m burbuja).
  function calcularRelleno(e) {
    if (!e) return null;
    var cl = num(e.cajaL), ca = num(e.cajaA), ch = num(e.cajaH);
    var pl = num(e.prodL), pa = num(e.prodA), ph = num(e.prodH);
    var mat = e.material;
    var dims = [cl, ca, ch, pl, pa, ph];
    if (dims.some(function (v) { return v === null || v <= 0; })) return null;
    if (!(mat in ROLLO_DEFAULT_M)) return null;

    if (!cabe([pl, pa, ph], [cl, ca, ch])) return { error: 'no_cabe' };

    var vacioLitros = (cl * ca * ch - pl * pa * ph) / 1000;

    var r = { material: mat, vacioLitros: vacioLitros };

    if (mat === 'kraft') {
      r.metrosExactos = vacioLitros / LITROS_POR_METRO_KRAFT;
    } else {
      // Superficie del producto en cm² × 2 capas, a m²; con rollo de 1 m de
      // ancho los m² son metros lineales.
      r.m2PorPieza = CAPAS_BURBUJA * (2 * (pl * pa + pl * ph + pa * ph)) / 10000;
      r.metrosExactos = r.m2PorPieza / ANCHO_ROLLO_BURBUJA_M;
    }
    r.metrosPorCaja = aMedios(r.metrosExactos);

    var pedidos = num(e.pedidosMes);
    if (pedidos !== null && pedidos > 0) {
      var rollo = num(e.rolloMetros);
      if (rollo === null || rollo <= 0) rollo = ROLLO_DEFAULT_M[mat];
      var metrosMes = r.metrosPorCaja * pedidos;
      r.mensual = {
        metros: metrosMes,
        rolloMetros: rollo,
        rollos: Math.ceil(metrosMes / rollo)
      };
    }
    return r;
  }

  function num(x) {
    if (x === null || x === undefined || x === '') return null;
    var v = Number(String(x).replace(',', '.'));
    return isFinite(v) ? v : null;
  }

  root.PPCalcRelleno = {
    ROLLO_DEFAULT_M: ROLLO_DEFAULT_M,
    calcularRelleno: calcularRelleno
  };
})(typeof window !== 'undefined' ? window : globalThis);

// ── Wiring de la página (no corre en tests de node) ────────────────────────
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  listo(function () {
    var raiz = document.querySelector('[data-pp-calc-relleno]');
    if (!raiz) return;
    var C = window.PPCalcRelleno;
    var $ = function (sel) { return raiz.querySelector(sel); };
    var form = $('form');
    var out = $('[data-calc-resultado]');

    var NOMBRE_MATERIAL = { kraft: 'papel kraft arrugado', burbuja: 'rollo de burbuja' };

    function fmt(n, dec) {
      return n.toLocaleString('es-MX', { maximumFractionDigits: dec === undefined ? 1 : dec });
    }

    // El campo de metros por rollo sigue al material mientras el usuario no
    // lo haya editado: kraft ⇒ 100, burbuja ⇒ 50.
    var selMaterial = form.querySelector('[name="material"]');
    var inRollo = form.querySelector('[name="rollo_metros"]');
    if (selMaterial && inRollo) {
      var defaultVigente = C.ROLLO_DEFAULT_M[selMaterial.value] || 100;
      selMaterial.addEventListener('change', function () {
        var nuevo = C.ROLLO_DEFAULT_M[selMaterial.value];
        if (!nuevo) return;
        if (inRollo.value === '' || inRollo.value === String(defaultVigente)) {
          inRollo.value = String(nuevo);
        }
        defaultVigente = nuevo;
      });
    }

    function correr() {
      var f = new FormData(form);
      var r = C.calcularRelleno({
        cajaL: f.get('caja_largo'), cajaA: f.get('caja_ancho'), cajaH: f.get('caja_alto'),
        prodL: f.get('prod_largo'), prodA: f.get('prod_ancho'), prodH: f.get('prod_alto'),
        material: f.get('material'),
        pedidosMes: f.get('pedidos_mes'),
        rolloMetros: f.get('rollo_metros')
      });
      pintar(r);
      dibujar3d(r, f);
    }

    // La caja con tu producto y el HUECO pintado en tono kraft translúcido:
    // "este aire es el que llenas con relleno" (motor compartido).
    function dibujar3d(r, f) {
      var cont = raiz.querySelector('[data-calc-dibujo-3d]');
      if (!cont || !window.PPCaja3D || !window.PPCaja3D.montar) return;
      if (!r || r.error) { if (cont) cont.hidden = true; return; }
      var aN = function (x) { return Number(String(x || '').replace(',', '.')); };
      var cl = aN(f.get('caja_largo')), ca = aN(f.get('caja_ancho')), ch = aN(f.get('caja_alto'));
      var pl = aN(f.get('prod_largo')), pa = aN(f.get('prod_ancho')), ph = aN(f.get('prod_alto'));
      if (!(cl > 0 && ca > 0 && ch > 0 && pl > 0 && pa > 0 && ph > 0)) { cont.hidden = true; return; }
      cont.hidden = false;
      var ori = window.PPCaja3D.mejorOrientacion([pl, pa, ph], [cl, ca, ch]);
      if (!ori) { cont.hidden = true; return; }
      var px = (cl - ori[0]) / 2, pz = (ca - ori[1]) / 2;
      var piezas = [{ dims: ori, pos: [px, 0, pz], color: 0 }];
      // El hueco como losas translúcidas kraft: los 4 costados y la tapa
      var HUECO = { color: 5, alfa: 0.35 };
      if (px > 0.4) {
        piezas.push({ dims: [px, ca, ori[2]], pos: [0, 0, 0], color: HUECO.color, alfa: HUECO.alfa });
        piezas.push({ dims: [px, ca, ori[2]], pos: [cl - px, 0, 0], color: HUECO.color, alfa: HUECO.alfa });
      }
      if (pz > 0.4) {
        piezas.push({ dims: [ori[0], pz, ori[2]], pos: [px, 0, 0], color: HUECO.color, alfa: HUECO.alfa });
        piezas.push({ dims: [ori[0], pz, ori[2]], pos: [px, 0, ca - pz], color: HUECO.color, alfa: HUECO.alfa });
      }
      var arriba = ch - ori[2];
      if (arriba > 0.4) {
        piezas.push({ dims: [cl, ca, arriba], pos: [0, ori[2], 0], color: HUECO.color, alfa: HUECO.alfa });
      }
      window.PPCaja3D.montar(cont, {
        caja: [cl, ca, ch],
        piezas: piezas,
        etiqueta: 'Lo translúcido es el hueco que llenas con ' + (r.material === 'burbuja' ? 'burbuja' : 'kraft') + ' (' + r.vacioLitros.toFixed(1) + ' L de aire) — arrástralo para girarlo'
      });
    }

    function pintar(r) {
      if (!out) return;
      out.hidden = false;
      if (!r) {
        out.innerHTML = '<p class="pp-calc__error">Revisa los datos: las seis medidas deben ser mayores a cero.</p>';
        return;
      }
      if (r.error === 'no_cabe') {
        out.innerHTML = '<p class="pp-calc__error">Tu producto no cabe en esa caja, ni girándolo. Revisa que las medidas de la caja sean las interiores — o búscale una caja más grande antes de pensar en relleno.</p>';
        return;
      }
      var esKraft = r.material === 'kraft';
      var html = '<div class="pp-calc__veredicto pp-calc__veredicto--ok">';
      html += '<p class="pp-calc__veredicto-titulo">Necesitas ≈ ' + fmt(r.metrosPorCaja) + ' m de ' + NOMBRE_MATERIAL[r.material] + ' por caja</p>';
      if (esKraft) {
        html += '<p class="pp-calc__veredicto-dato">Tu caja deja <strong>' + fmt(r.vacioLitros) + ' litros</strong> de vacío alrededor del producto. Con la regla práctica de 1 m de kraft ≈ 8 litros, salen ' + fmt(r.metrosExactos, 2) + ' m — redondeados a ' + fmt(r.metrosPorCaja) + ' m para que no te quedes corto.</p>';
      } else {
        html += '<p class="pp-calc__veredicto-dato">La burbuja envuelve el producto, no llena el vacío: con 2 vueltas por cara tu pieza pide <strong>' + fmt(r.m2PorPieza, 2) + ' m²</strong>, que en rollo de 1 m de ancho son ' + fmt(r.metrosPorCaja) + ' m lineales.</p>';
      }
      if (r.mensual) {
        html += '<p class="pp-calc__veredicto-dato">Con tus pedidos al mes: <strong>' + fmt(r.mensual.metros) + ' m mensuales</strong> — compra <strong>' + fmt(r.mensual.rollos, 0) + ' ' + (r.mensual.rollos === 1 ? 'rollo' : 'rollos') + '</strong> de ' + fmt(r.mensual.rolloMetros, 0) + ' m.</p>';
      }
      html += '</div>';
      html += '<dl class="pp-calc__detalle">';
      html += '<div class="pp-calc__detalle-fila"><dt>Vacío por rellenar</dt><dd>' + fmt(r.vacioLitros) + ' L</dd></div>';
      if (!esKraft) {
        html += '<div class="pp-calc__detalle-fila"><dt>Burbuja por pieza (2 capas)</dt><dd>' + fmt(r.m2PorPieza, 2) + ' m²</dd></div>';
      }
      html += '<div class="pp-calc__detalle-fila"><dt>' + (esKraft ? 'Kraft' : 'Burbuja') + ' por caja</dt><dd>' + fmt(r.metrosPorCaja) + ' m</dd></div>';
      if (r.mensual) {
        html += '<div class="pp-calc__detalle-fila"><dt>Consumo mensual</dt><dd>' + fmt(r.mensual.metros) + ' m · ' + fmt(r.mensual.rollos, 0) + ' ' + (r.mensual.rollos === 1 ? 'rollo' : 'rollos') + '</dd></div>';
      }
      html += '</dl>';
      html += '<p class="pp-calc__nota">Regla práctica de Para Paquetes — ajusta a tu producto: un jarrón pide más vueltas de burbuja que un libro, y el kraft rinde distinto según qué tanto lo arrugues.</p>';
      out.innerHTML = html;
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      correr();
      if (out) out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    var timerRecalc = null;
    function recalcEnVivo() {
      if (!out || out.hidden) return;
      clearTimeout(timerRecalc);
      timerRecalc = setTimeout(function () { correr(); }, 350);
    }
    form.addEventListener('input', recalcEnVivo);
    form.addEventListener('change', recalcEnVivo);
  });
})();
